// Modules catalog data layer — typed wrapper over GET /modules
// (backend/src/routes/modules.routes.ts). Powers the catalog-driven "Licensed
// Modules" checkbox list on LicenseCreate and the per-org module switches on
// Fleet.
import { apiRequest } from '@/lib/supabase';

export interface ModuleCatalogRow {
  code: string;
  name: string;
  description: string | null;
  active: boolean;
}

// An ACTIVE license_tier module grant (migration 27 module_grants). Present only
// when an operator has flipped the row live (grants ship dark), so this list
// reflects exactly what the signing seam will derive for a tier.
export interface TierGrantRow {
  source_code: string; // the license tier (startup|professional|enterprise|…)
  granted_code: string; // the implied module code
  default_term_days: number | null; // null = perpetual, N = trial term
}

export interface ModulesCatalog {
  modules: ModuleCatalogRow[];
  tierGrants: TierGrantRow[];
}

export async function fetchModulesCatalog(): Promise<ModulesCatalog> {
  const resp = await apiRequest<ModulesCatalog>('/modules');
  return {
    modules: Array.isArray(resp?.modules) ? resp.modules : [],
    tierGrants: Array.isArray(resp?.tierGrants) ? resp.tierGrants : [],
  };
}

// Which module codes a given license tier derives (checked+disabled in the UI),
// mapped to the grant's term. Empty until an operator flips a grant row live.
export function derivedModulesForTier(
  tier: string,
  tierGrants: TierGrantRow[]
): Record<string, { termDays: number | null }> {
  const out: Record<string, { termDays: number | null }> = {};
  for (const g of tierGrants) {
    if (g.source_code === tier) out[g.granted_code] = { termDays: g.default_term_days };
  }
  return out;
}
